import { render, staticRenderFns } from "./add-remove-button.vue?vue&type=template&id=21ff0730&scoped=true"
import script from "./add-remove-button.vue?vue&type=script&lang=js"
export * from "./add-remove-button.vue?vue&type=script&lang=js"
import style0 from "./add-remove-button.vue?vue&type=style&index=0&id=21ff0730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ff0730",
  null
  
)

export default component.exports